import { endpoint } from './default';

const login = (data, tag) => endpoint.post(`/login?tag=${tag}`, data);

const getAllUser = () => endpoint.get('/codingwizard/all', {
  params: {
    tag: 'CodingWizard',
  },
});

const getUserInfoById = (id) => endpoint.get(`/codingwizard/${id}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const createNewUser = (data) => endpoint.post('/codingwizard', data, {
  params: {
    tag: 'CodingWizard',
  },
});

const updateUser = (data, id) => endpoint.put(`/codingwizard/${id}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

const deleteUser = (id) => endpoint.delete(`/codingwizard/delete/${id}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

const getUserByRole = (role) => endpoint.get(`/codingwizard/role/${role}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getAnalysis = (start, end) => endpoint.get(`/codingwizard/analysis/${start}/${end}`, {
  params: {
    tag: 'CodingWizard',
  },
});

export {
  login,
  getAllUser,
  getUserInfoById,
  createNewUser,
  updateUser,
  deleteUser,
  getUserByRole,
  getAnalysis,
};
